// 封装一个公共的 HTTP 请求类
import BaseService from "@/api/base";

class LoggerService  extends BaseService {

    // 基础的 API 地址
    private search_at_page_path = "/1password/api/v1/logger/search_at_page"

    // 封装 GET 请求方法
    public async searchAtPage(query: any = {}): Promise<any> {
        return await this.getFetchData(this.search_at_page_path, query);
    }

}

export default LoggerService;
